// Shared chrome for every page: header + mobile menu, footer, the tilted page
// transition between pages, scroll reveals. Needs shell.js (VOLT) loaded first.
(function () {
  const L = (da, en) => `<span data-l="da">${da}</span><span data-l="en">${en}</span>`;
  const MENU = [
    { href: 'join.html', page: 'join', label: L('Bliv Volt', 'Join') },
    { href: 'partner.html', page: 'partner', label: L('Partner', 'Partner') },
    { href: 'about.html', page: 'about', label: L('Om os', 'About') },
    { href: 'contact.html', page: 'contact', label: L('Kontakt', 'Contact') },
  ];
  const FOOTER = [
    { h: L('Virksomhed', 'Company'), links: [
      ['join.html', L('Become Volt', 'Become Volt')], ['about.html', L('Om Volt', 'About Volt')],
      ['contact.html', L('Kontakt os', 'Contact Us')], ['accessibility.html', L('Tilgængelighed', 'Accessibility')]] },
    { h: L('Juridisk', 'Legal'), links: [
      ['terms.html', L('Handelsbetingelser', 'Terms & Conditions')], ['privacy.html', L('Privatlivspolitik', 'Privacy Policy')],
      ['volunteer-terms.html', L('Frivilligebetingelser', 'Volunteer Terms')], ['dpa.html', L('Databehandleraftale', 'Data Processing Agreement')]] },
    { h: L('Forretning', 'Business'), links: [
      ['partner.html', L('Volt for Business', 'Volt for Business')], ['technology.html', L('Teknologi', 'Technology')]] },
    { h: 'We are social!', links: [
      ['https://facebook.com/getvolt', 'Facebook'], ['https://www.instagram.com/getvolt', 'Instagram'],
      ['https://tiktok.com/@getvolt', 'TikTok'], ['https://www.linkedin.com/company/getvolt', 'LinkedIn']] },
  ];

  function header(page) {
    const items = MENU.map(m => m.spacer ? '<span class="spacer"></span>'
      : `<div class="item"><a href="${m.href}" class="${m.page === page ? 'on' : ''}">${m.label}</a></div>`).join('');
    return `<header class="hdr">
      <a class="logo" href="index.html"><img class="white" src="brand/logo-white.svg" alt="Volt"><img class="ink" src="brand/logo-dark.svg" alt="Volt"></a>
      <button class="burger" aria-label="Menu"><i class="l1"></i><i class="l2"></i><i class="l3"></i><i class="x x1"></i><i class="x x2"></i></button>
      <nav class="menu small">${items}<span class="spacer"></span>
        <div class="lang"><button data-lang="da">DA</button><button data-lang="en">EN</button></div></nav>
    </header>`;
  }
  function footer() {
    const cols = FOOTER.map(c => `<div><h4 class="small">${c.h}</h4><ul>${c.links.map(([h, t]) =>
      `<li><a href="${h}"${h.startsWith('http') ? ' target="_blank" rel="noopener"' : ''}>${t}</a></li>`).join('')}</ul></div>`).join('');
    return `<footer class="ftr"><div class="ftr-grid">
      <div class="ftr-brand"><img src="brand/logo-white.svg" alt="Volt"><p>${L('Festival tech gjort nemt. Vi leverer opladning, lockers og lyd til 170+ events i Europa.',
        'Festival tech made easy. We power charging, lockers and sound at 170+ events across Europe.')}</p></div>${cols}</div>
      <div class="ftr-bottom"><span>&copy; ${new Date().getFullYear()} Volt ApS &middot; CVR DK42439916</span><em>Made for Festival</em></div></footer>`;
  }

  // ---- page transition ----
  const WIPE = 'volt-wipe';
  let T;
  function leaveTo(href) {
    document.body.classList.remove('menu-open');
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { location.href = href; return; }
    try { sessionStorage.setItem(WIPE, '1'); } catch {}
    T.classList.add('visible');
    setTimeout(() => location.href = href, 760);
  }
  function arrive() {
    let wiped = false; try { wiped = sessionStorage.getItem(WIPE); sessionStorage.removeItem(WIPE); } catch {}
    if (!wiped) return;
    T.classList.add('instant', 'visible'); void T.offsetWidth; T.classList.remove('instant');
    requestAnimationFrame(() => { T.classList.add('hide'); setTimeout(() => T.classList.remove('hide', 'visible'), 760); });
  }
  // back/forward cache: never come back to a covered page
  addEventListener('pageshow', e => { if (e.persisted && T) T.className = 'transition'; });

  function isInternal(a) {
    const h = a.getAttribute('href') || '';
    return h && !h.startsWith('#') && !/^(https?:|mailto:|tel:)/.test(h) && a.target !== '_blank';
  }

  function reveals() {
    const els = [...document.querySelectorAll('[data-reveal]:not(.in)')];
    if (!('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('in')); return; }
    // Anything that sits on the first screen reveals right after arrival. The
    // observer alone can miss titles: their entrance transform pushes them 500px
    // down, so on a short screen they would never count as visible.
    const top = el => { let y = 0; for (let n = el; n; n = n.offsetParent) y += n.offsetTop; return y; };
    const first = els.filter(e => top(e) < innerHeight);
    setTimeout(() => first.forEach(e => e.classList.add('in')), 350);
    const io = new IntersectionObserver(es => es.forEach(x => { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } }),
      { rootMargin: '0px 0px -8% 0px' });
    els.filter(e => !first.includes(e)).forEach(e => io.observe(e));
  }


  // ---- the lava corner ----
  // Blobs drift in the right-hand corner of a light page and merge where they
  // meet, like a lava lamp: each colour group is blurred and then the alpha is
  // pushed back up to a hard edge (the "goo" filter), so overlapping circles
  // fuse into one shape. Yellow blobs, with dark ones drifting over them, after
  // Otto's two-tone corner. Anchored past the right edge so it reads as a corner.
  // Five kinds, one picked at random per page load. Each blob is
  // [x, y, r, drift x, drift y, speed, phase, layer]; layers: y = yellow,
  // d = dark, h = halftone (dark dots, after Otto's halftone corners).
  const KINDS = {
    twotone: [ [270, 90, 88, 26, 40, .21, 0, 'y'], [300, 230, 110, 18, 46, .17, 1.9, 'y'], [250, 360, 70, 30, 34, .25, 3.1, 'y'],
               [320, 420, 84, 16, 30, .19, 4.4, 'y'], [205, 210, 34, 38, 70, .23, 2.6, 'y'],
               [300, 150, 46, 30, 60, .27, .8, 'd'], [262, 300, 30, 40, 54, .31, 5.2, 'd'], [318, 380, 38, 22, 40, .24, 2.2, 'd'] ],
    yellow:  [ [280, 110, 96, 30, 44, .18, 0, 'y'], [300, 260, 120, 22, 50, .15, 2.1, 'y'], [240, 390, 64, 34, 40, .23, 3.4, 'y'],
               [210, 180, 40, 40, 80, .26, 1.2, 'y'], [330, 440, 80, 18, 26, .2, 4.8, 'y'] ],
    bubbles: [ [300, 120, 70, 20, 30, .16, 0, 'y'], [320, 300, 90, 14, 40, .14, 2.4, 'y'],
               [235, 80, 18, 30, 120, .34, .5, 'y'], [255, 250, 24, 26, 140, .29, 1.7, 'y'], [215, 400, 16, 34, 110, .37, 3.3, 'y'],
               [270, 440, 22, 30, 130, .31, 4.1, 'y'], [190, 300, 12, 24, 150, .4, 5.6, 'y'], [245, 170, 14, 20, 120, .42, 2.9, 'd'] ],
    halftone:[ [290, 130, 92, 24, 40, .19, 0, 'y'], [305, 300, 104, 20, 44, .16, 2.3, 'y'],
               [230, 230, 120, 30, 50, .14, 1.1, 'h'], [250, 420, 90, 26, 36, .17, 3.9, 'h'] ],
    dark:    [ [290, 120, 84, 26, 40, .2, 0, 'd'], [310, 280, 100, 20, 46, .17, 2, 'd'], [250, 400, 60, 30, 36, .24, 3.2, 'd'],
               [215, 200, 30, 36, 70, .28, 1.4, 'y'] ],
  };
  const KIND = Object.keys(KINDS)[Math.floor(Math.random() * Object.keys(KINDS).length)];
  let lavaN = 0;
  // ids are per drawing: two lavas on one page must not share a filter or mask
  function lavaSvg(kind = KIND, cls = 'corner lava') {
    const B = KINDS[kind], u = 'lv' + (++lavaN);
    const c = col => B.map((b, i) => b[7] === col ? `<circle data-i="${i}" cx="${b[0]}" cy="${b[1]}" r="${b[2]}"/>` : '').join('');
    return `<svg class="${cls}" data-kind="${kind}" viewBox="0 0 340 480" aria-hidden="true" focusable="false">
      <defs><filter id="${u}g" x="-30%" y="-30%" width="160%" height="160%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="14" result="b"/>
        <feColorMatrix in="b" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 26 -11"/></filter>
        <pattern id="${u}d" width="9" height="9" patternUnits="userSpaceOnUse"><circle cx="4.5" cy="4.5" r="2.3" style="fill: var(--ink)"/></pattern>
        <mask id="${u}m"><g filter="url(#${u}g)" fill="#fff">${c('h')}</g></mask></defs>
      <g filter="url(#${u}g)" style="fill: var(--gold)">${c('y')}</g>
      <rect width="340" height="480" fill="url(#${u}d)" mask="url(#${u}m)"/>
      <g filter="url(#${u}g)" style="fill: var(--ink)">${c('d')}</g></svg>`;
  }
  // Placement: the left or right edge at a random height, then it keeps
  // moving around the site: a slow glide to a new height every ~14 s, and
  // every third move it fades out and comes back on the other side.
  function lavaPlace(svg) {
    if (!svg) return;
    const H = () => svg.getBoundingClientRect().height || 300;
    const spot = () => Math.round(110 + Math.random() * Math.max(0, innerHeight - H() - 140));
    let left = Math.random() < .5;
    svg.classList.add(left ? 'on-left' : 'on-right');
    svg.style.top = spot() + 'px';
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let n = 0;
    setInterval(() => {
      if (document.hidden) return;
      if (++n % 3 === 0) {
        svg.style.opacity = '0';
        setTimeout(() => {
          left = !left;
          svg.classList.toggle('on-left', left); svg.classList.toggle('on-right', !left);
          svg.style.transition = 'none'; svg.style.top = spot() + 'px';
          requestAnimationFrame(() => { svg.style.transition = ''; svg.style.opacity = '1'; });
        }, 1300);
      } else svg.style.top = spot() + 'px';
    }, 14000);
  }
  function lavaRun(svg) {
    if (!svg || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const B = KINDS[svg.dataset.kind];
    const dots = [...svg.querySelectorAll('circle[data-i]')].map(n => [n, B[+n.dataset.i]]);   // not the halftone pattern's dot
    let on = true;
    new IntersectionObserver(es => on = es[0].isIntersecting).observe(svg);   // rest when scrolled away
    (function tick(now) {
      if (on) {
        const t = now / 1000;
        for (const [n, [x, y, r, ax, ay, f, p]] of dots) {
          // lava-lamp motion: slow, long rises and falls (vertical travel ~1.8x the
          // listed drift), a little sideways sway; blobs meet, fuse and pull apart
          const tt = t * f * .7;
          n.setAttribute('cx', (x + ax * Math.sin(tt * 1.3 + p)).toFixed(1));
          n.setAttribute('cy', (y + ay * 1.8 * Math.sin(tt + p * 1.3) + ay * .4 * Math.sin(tt * 2.1 + p)).toFixed(1));
          n.setAttribute('r', (r * (1 + .08 * Math.sin(t * f * 1.4 + p))).toFixed(1));
        }
      }
      requestAnimationFrame(tick);
    })(performance.now());
  }

  function mount(opts = {}) {
    const page = opts.page || '';
    // a Shopify theme renders header and footer in Liquid; only inject when absent
    if (!document.querySelector('.hdr')) document.body.insertAdjacentHTML('afterbegin', header(page));
    document.body.insertAdjacentHTML('beforeend', '<div class="transition" id="transition"></div>');
    T = document.getElementById('transition');
    const main = document.querySelector('main.pg');
    if (main && document.body.classList.contains('light') && !document.body.classList.contains('template-cart')) { main.insertAdjacentHTML('afterbegin', lavaSvg()); lavaPlace(main.querySelector('.corner')); lavaRun(main.querySelector('.corner')); }
    const slot = document.getElementById('footer-slot');
    if (document.querySelector('.ftr')) {} else if (slot) slot.outerHTML = footer(); else if (opts.footer) document.body.insertAdjacentHTML('beforeend', footer());

    document.querySelector('.burger').onclick = () => document.body.classList.toggle('menu-open');
    document.querySelectorAll('[data-lang]').forEach(b => b.onclick = () => VOLT.setLang(b.dataset.lang));
    const markLang = l => document.querySelectorAll('[data-lang]').forEach(b => b.classList.toggle('on', b.dataset.lang === l));
    VOLT.onLang(markLang);

    // every internal link leaves through the tilted panel; the home page can
    // claim links to itself (Events) and switch view in place instead
    document.addEventListener('click', e => {
      const a = e.target.closest('a'); if (!a || !isInternal(a) || e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      const href = a.getAttribute('href');
      if (opts.onLocal && opts.onLocal(href)) { document.body.classList.remove('menu-open'); return; }
      leaveTo(href);
    });

    // the reel: a click plays it with sound, the next click stops it; no controls, no full screen
    document.querySelectorAll('[data-reel]').forEach(f => {
      const v = f.querySelector('video');
      f.onclick = () => { if (v.paused) { v.muted = false; v.play(); } else v.pause(); };
      v.onplay = () => f.classList.add('playing'); v.onpause = v.onended = () => f.classList.remove('playing');
    });

    VOLT.setLang(VOLT.lang);
    markLang(VOLT.lang);
    arrive();
    reveals();
  }

  window.SITE = { mount, reveals, leaveTo, transition: () => T, lava: { kinds: Object.keys(KINDS), svg: lavaSvg, run: lavaRun } };
})();
